<template>
  <v-card>
    <v-app-bar flat dense color="rgba(0, 0, 0, 0)">
      <v-toolbar-title> Item List </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="closeProductDialog" color="error" outlined small>
        <v-icon>mdi-close</v-icon></v-btn>
    </v-app-bar>

    <v-data-table :loading="loading" :headers="headers" :items="ITEMS.data" class="elevation-1" hide-default-footer
      show-expand :expanded.sync="expanded" :single-expand="true" @click:row="dataTableRowClicked">
      <template v-slot:no-data> No data </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn color="primary" outlined small @click.stop="selectProduct(item)">Select <v-icon right> mdi-check
          </v-icon></v-btn>
      </template>

      <template v-slot:[`item.is_active`]="{ item }">
        <v-icon v-if="item.is_active == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:[`item.use_ingredient`]="{ item }">
        <v-icon v-if="item.use_ingredient == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:[`item.printing`]="{ item }">
        <v-icon v-if="item.printing == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:[`item.perforation`]="{ item }">
        <v-icon v-if="item.perforation == 1" color="success" class="text-center">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col cols="12" class="mt-5">
              <p class="mb-1">
                <span><strong>Description :</strong> </span>
                {{ item.description ? item.description : "N/A" }}
              </p>
              <hr />
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:[`item.price_buy`]="{ item }">
        <b>{{ item.price_buy | currency("", 0, { symbolOnLeft: false, }) }}</b>
      </template>

      <template v-slot:[`item.total`]="{ item }">
        <b>{{ item.total | currency("", 0, { symbolOnLeft: false, }) }}</b>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <base-column :lg="4" :md="4" :sm="6">
            <v-text-field v-model="search.search" append-icon="mdi-magnify" label="Search" outlined dense
              hide-details></v-text-field>
          </base-column>
          <base-column :lg="4" :md="4" :sm="6">
            <v-switch v-model="search.use_ingredient" :change="use_ingredient()" class="mt-1" label="Use Ingredient">
            </v-switch>
          </base-column>

          <v-btn small color="darkblue" class="white--text float-end mx-1" @click.stop="searching">Submit <v-icon
              right>mdi-magnify</v-icon></v-btn>
          <v-btn small color="secondary" class="white--text float-end mx-1" @click.stop="clear">Clear
            <v-icon right>mdi-close-circle-multiple </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template>
        <v-icon color="warning" class="mr-2"> mdi-pencil-box-outline </v-icon>
      </template>
    </v-data-table>
    <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import BaseColumn from "@/components/base/BaseColumn.vue";
export default {
  name: "ProductsModal",

  created() {
    this.getProduct();
  },

  data() {
    return {
      headers: [
        { text: "Item Code", value: "code" },
        { text: "Item Name", value: "name" },
        { text: "Branch", value: "branch.name" },
        { text: "Subgroup", value: "subgroup.name" },
        { text: "Stock Qty", value: "stock" },
        { text: "Price Buy", value: "price_buy" },
        { text: "Price Sell", value: "total" },
        { text: "Use Ingredient", value: "use_ingredient" },
        { text: "Status", value: "is_active" },
        { text: "Action", value: "actions", sortable: false, width: 100 },
      ],
      page: 1,
      expanded: [],
      loading: false,
      disabled: false,
      search: {
        search: null,
        use_ingredient: 0,
        status: "Active",
      },
    };
  },
  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.getProduct();
    },
  },
  methods: {
    async getProduct() {
      this.loading = true;
      let params = {
        page: this.page,
        search: this.search.search,
        status: this.search.status,
        use_ingredient: this.search.use_ingredient,
      };
      await this.$axios("/master/item?is_active=1", {
        params: params,
        headers: {
          Authorization: this.$store.getters["auth/Token"],
        },
      }).then(({ data }) => {
        this.$store.commit("item/SET_ITEMS", data.item);
        this.loading = false;
        this.disabled = false;
      });
    },
    use_ingredient() {
      if (this.search.use_ingredient == true) {
        this.search.use_ingredient = 1;
      } else {
        this.search.use_ingredient = 0;
      }
    },

    searching() {
      this.page = 1;
      this.getProduct();
    },
    clear() {
      this.page = 1;
      this.search = {
        status: "",
        search: "",
      };
      this.getProduct();
    },
    closeProductDialog() {
      this.$emit("closeProductDialog");
    },

    selectProduct(item) {
      this.$emit("selectProduct", item);
      this.closeProductDialog();
    },

    removeProduct(item) {
      this.$emit("removeProduct", item);
    },
    dataTableRowClicked(item) {
      if (item === this.expanded[0]) {
        this.expanded = [];
      } else {
        this.expanded = [item];
      }
    },
  },

  computed: {
    ...mapGetters("item", {
      ITEMS: "Items",
    }),
    currentPage: {
      get() {
        return this.ITEMS.current_page;
      },
      set(val) {
        return this.$store.commit("item/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.ITEMS.last_page;
      },
    },
  },

  components: {
    BaseColumn,
  },
};
</script>